<template>
  <div>
    <rj-tabs v-model="tabsActive" @change="handleTabChange">
      <rj-tab-pane name="1">
        <span slot="label">待上传(确收)</span>
        <pendingIncomeConfirmation ref="pendingIncomeConfirmation" />
      </rj-tab-pane>
      <rj-tab-pane name="2">
        <span slot="label">已上传(确收)</span>
        <incomeConfirmed ref="incomeConfirmed" />
      </rj-tab-pane>
      <!-- <rj-tab-pane name="3">
        <span slot="label">待上传(非确收)</span>
        <notPendingIncomeConfirmation />
      </rj-tab-pane>
      <rj-tab-pane name="4">
        <span slot="label">已上传(非确收)</span>
        <notIncomeConfirmed />
      </rj-tab-pane> -->
    </rj-tabs>
  </div>
</template>

<script>
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import pendingIncomeConfirmation from './pendingIncomeConfirmation.vue';
import incomeConfirmed from './incomeConfirmed.vue';

export default {
  name: 'UploadIncomeConfirmation',
  components: {
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    pendingIncomeConfirmation,
    incomeConfirmed
  },
  data () {
    return {
      tabsActive: '1'
    };
  },
  methods: {
    handleTabChange () {
      this.$refs.pendingIncomeConfirmation.collapseExpandedDetails();
      this.$refs.incomeConfirmed.collapseExpandedDetails();
      if (this.tabsActive === '2') {
        this.$refs.incomeConfirmed.doSearch();
      }
    }
  }
};
</script>
